import React, { lazy, Suspense } from 'react';
import { Route, Routes } from "react-router-dom";

const Login = lazy(() => import('../pages/auth/Login'));
const ResetPassword = lazy(() => import('../pages/auth/ResetPassword'));

export default function AuthRoutes(){
    return(
        <Suspense fallback={<div className='flex items-center justify-center w-full h-screen font-bold text-lg'>Loading..</div>}>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/reset-password" element={<ResetPassword />} />
            </Routes>
        </Suspense>
        
    )
}
